// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__3mn7V","label":"SetPasswdForm_label__38Tnj"};